import React from "react";

const CancellationPolicy = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <h1>Cancellation Policy</h1>

      <p>
        Orders can be cancelled only before they are shipped. Once shipped, the
        order cannot be cancelled.
      </p>

      <h2>How to Cancel</h2>
      <p>Email us at <strong>kwicth.clothes@gmail.com</strong></p>
    </div>
  );
};

export default CancellationPolicy;
